import React, {FC} from 'react';
import cls from "./blocks.module.scss"

const BlockLoader: FC = () => {
    return (
        <div className={cls["block-loader"]}>
            <div className={cls["block-loader__spinner"]}/>
        </div>
    );
}

export default BlockLoader